import { v4 as uuidv4 } from "uuid";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  computed: {
    currentPage() {
      return this.$route.path;
    },
    ...mapGetters({
      services: "service/services",
      isCreatingOrder: "order/isCreatingOrder",
    }),
  },

  created() {
    this.getServices();
  },

  methods: {
    ...mapActions({
      getServices: "service/getServices",
      setUuid: "order/setUuid",
      setComplexitykeysinfo: "order/setComplexitykeysinfo",
    }),

    ...mapMutations({
      SET_SELECTED_SERVICE: "service/SET_SELECTED_SERVICE",
      SET_SELECTED_ORDER_SERVICEID: "order/SET_SELECTED_SERVICEID",
      RESET_ORDER: "order/RESET_ORDER",
    }),

    async setSelectedService(service) {
      if (this.currentPage.includes(service.slug + "/")) {
        return;
      }

      if (this.isCreatingOrder) {
        const confirm = await this.$swal({
          title: "⚠️ Order In-progress",
          text:
            "You are currently in the middle of an order, if you leave it will not be submitted.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Leave",
          cancelButtonText: "Cancel",
        });
        if (!confirm.value) {
          return;
        }
      }

      this.SET_SELECTED_SERVICE(service);
      this.SET_SELECTED_ORDER_SERVICEID(service.id);
      this.RESET_ORDER();
      this.setUuid({
        uuid: uuidv4(),
      });
      service.complexities.map((complexity) => {
        this.setComplexitykeysinfo(complexity);
      });
      this.$router.push({
        name: "step-one",
        params: { slug: service.slug },
      });
    },
  },
};
